export enum SliderTypes {
	PressRelease = 'press-release',
	Testimonial = 'testimonial',
	Events = 'events',
	Stories = 'stories',
	ImageGallery = 'image-gallery',
}

const SwiperGridDefinitions = {
	[SliderTypes.Events]: {
		320: {
			slidesPerView: 1,
		},
		670: {
			slidesPerView: 2,
		},
		1440: {
			slidesPerView: 2,
		},
	},
	[SliderTypes.ImageGallery]: {
		320: {
			sliderPerView: 1,
		},
	},
	default: {
		320: {
			slidesPerView: 1,
		},
		670: {
			slidesPerView: 2,
		},
		1063: {
			slidesPerView: 3,
		},
	},
};

/**
 * Returns a specified grid definition or the default grid definition if not defined.
 * @param key
 * @returns
 */
export const getGridDefinition = (key: SliderTypes) => SwiperGridDefinitions[key] ?? SwiperGridDefinitions.default;
